import { sendEvent } from '@utils/core/track';
import { os } from '@utils/device-utils';
import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useCallback, useEffect, useState } from 'react';
import styles from './styles.scss';


const LessonSection: FC = () => {
	const { width } = useResizeObserver()
	const [activeIndex, setActiveIndex] = useState(0);
	const [isShowHand, setShowHand] = useState(true);
	const { transData, list } = useTranslation('happyKids.lesson')

	const ListRender = useCallback((listArray: typeof list[0]) => {
		if (list.length == 0) return []

		return listArray.map((item: { img: string }, index: React.Key | undefined) => {
			return (
				<div
					key={index}
					className={styles['li-item']}
				>
					<img loading='lazy' src={item.img} alt="" />
				</div>
			)
		})
	}, [list])




	const onSetTranslate = (swiper: any, progress: number) => {
		const swiperWidth = swiper.width;
		const swiperHeight = swiper.height;
		const slides = swiper.slides;
		const $wrapperEl = swiper.$wrapperEl;
		const slidesSizesGrid = swiper.slidesSizesGrid;
		const params = swiper.params.coverflowEffect;
		const isHorizontal = swiper.isHorizontal();
		const transform = swiper.translate;
		const center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
		const rotate = isHorizontal ? params.rotate : -params.rotate;
		const translate = params.depth;
		for (let i = 0; i < swiper.slides.length; i++) {
			const $slideEl = slides.eq(i);
			const slideSize = slidesSizesGrid[i];
			const slideOffset = $slideEl[0].swiperSlideOffset;
			const offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
			const slideProgress = swiper.slides[i].progress;

			// const rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
			let rotateY = 0;
			let rotateX = 0;
			let rotateZ = rotate * offsetMultiplier;
			// const rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
			// const rotateZ = 0
			let translateZ = 0 || -translate * Math.abs(offsetMultiplier);

			let stretch = params.stretch;
			// Allow percentage to make a relative stretch for responsive sliders
			if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
				stretch = ((parseFloat(params.stretch) / 100) * slideSize);
			}
			let translateY = Math.abs(stretch * (offsetMultiplier));
			let translateX = isHorizontal ? stretch * (offsetMultiplier) : 0;
			// Fix for ultra small values


			if (Math.abs(translateX) < 0.001) { translateX = 0; }
			if (Math.abs(translateY) < 0.001) { translateY = 0; }
			if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
			if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
			if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
			if (Math.abs(rotateZ) < 0.001) { rotateZ = 0; }

			if (width >= 1192) {
				if (slideProgress == 1) { translateY = 72; translateX = 290 }
				if (slideProgress == -1) { translateY = 15; translateX = -275 }
				if (slideProgress == -2) { translateY = 86; translateX = -760 }
			}
			if (width < 1192 && width >= 768) {

				if (slideProgress == 1) { translateY = 52; translateX = 153 }
				if (slideProgress == -1) { translateY = 8; translateX = -250 }
				if (slideProgress == -2) { translateY = 54; translateX = -584 }
				if (slideProgress == 0) { translateY = 0; translateX = -55 }
			}
			if (width < 768) {
				if (slideProgress == 1) { translateY = 33; translateX = 105 }
				if (slideProgress == -1) { translateY = 8; translateX = -160 }
				if (slideProgress == -2) { translateY = 43; translateX = -380 }
				if (slideProgress == 0) { translateY = 0; translateX = -31 }
			}


			let scale = 1 - Math.abs(slideProgress) / 5;
			if (scale <= 0.8) { scale = 0.67; }
			const slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + 0 + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) rotateZ(" + rotateZ + "deg) scale(" + scale + ")";
			$slideEl.transform(slideTransform)
			$slideEl.css('opacity', 0);

			if (slideProgress > - 3 && slideProgress < 2) {
				$slideEl.css('opacity', 1);
			}
		}
	};



	return (
		<section className={styles['ac-lesson']}>
			<div className={styles['ac-lesson-container']}>
				<img loading='lazy' src={!activeIndex ? 'https://web-data.zmlearn.com/image/6Zk2ytwX8WdopsmnKGAykq/P1-bg-%E8%8B%B1%E6%96%87%402x%20(1).png' : 'https://web-data.zmlearn.com/image/rXPQcNm6c5xVXSYS6yyaLn/P1-bg-%E6%95%B0%E5%AD%A6%402x%202.png'} alt="" />
				<h1><span>{transData.title}</span></h1>
				<AcSwipe
					className={classnames(styles['ac-lesson-banner'], 'ac-lesson-banner')}
					watchSlidesProgress
					slidesPerView={'auto'}
					centeredSlides
					loop
					// loopedSlides={4}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					allowTouchMove={false}
					// loopAdditionalSlides={3}
					effect={"coverflow"}
					coverflowEffect={{
						rotate: -15,
						stretch: 300,
						depth: 100,
						modifier: 1,
						slideShadows: false
					}}
					onSetTranslate={onSetTranslate}
				>{activeIndex ? ListRender(list[1]) : ListRender(list[0])}</AcSwipe>
				<div className={styles['ac-lesson-btn']}>
					{transData.buttons.map((item: string, index: number) => {
						return (
							<div key={index} onClick={() => {
								setShowHand(false);
								setActiveIndex(index)
								sendEvent({
									eventId: 'ACW_hk_subjectlevel',
								})
							}}
								style={{ backgroundImage: `url(${item})` }}
								className={classnames(styles['btn-' + (index + 1)], styles['btn'], index == activeIndex ? styles['active'] : '')}></div>
						)
					})}
					{isShowHand && <span className={styles['hand']} />}
				</div>
			</div>
		</section >
	);
}

export default LessonSection
